/**
 * Season 2 (2012) masteries — 30 points, max 21 per tree.
 * Named nodes from docs/game_specs/spells_runes_masteries.md.
 */

export const MASTERY_TOTAL_POINTS = 30;
export const MASTERY_TREE_CAP = 21;

export const MASTERY_CATALOG = Object.freeze({
  executioner: {
    id: 'executioner',
    tree: 'offense',
    name: 'Executioner',
    maxRank: 1,
    perRank: Object.freeze({ executeDamageAmp: 0.06 })
  },
  havoc: {
    id: 'havoc',
    tree: 'offense',
    name: 'Havoc',
    maxRank: 3,
    perRank: Object.freeze({ damageAmp: 0.015 })
  },
  sunder: {
    id: 'sunder',
    tree: 'offense',
    name: 'Sunder',
    maxRank: 3,
    perRank: Object.freeze({ armorPen: 2 })
  },
  hardiness: {
    id: 'hardiness',
    tree: 'defense',
    name: 'Hardiness',
    maxRank: 3,
    perRank: Object.freeze({ armor: 2 })
  },
  resistance: {
    id: 'resistance',
    tree: 'defense',
    name: 'Resistance',
    maxRank: 3,
    perRank: Object.freeze({ mr: 2 })
  },
  good_karma: {
    id: 'good_karma',
    tree: 'utility',
    name: 'Good Karma',
    maxRank: 2,
    perRank: Object.freeze({ goldPer10: 1 })
  },
  runic_affinity: {
    id: 'runic_affinity',
    tree: 'utility',
    name: 'Runic Affinity',
    maxRank: 1,
    perRank: Object.freeze({ buffDurationAmp: 0.2 })
  }
});

export const MASTERY_PAGE_PRESETS = Object.freeze({
  offense_21_9_0: Object.freeze({
    id: 'offense_21_9_0',
    name: '21/9/0 Offense',
    trees: Object.freeze({ offense: 21, defense: 9, utility: 0 }),
    ranks: Object.freeze({
      executioner: 1,
      havoc: 3,
      sunder: 3,
      hardiness: 3,
      resistance: 3
    })
  }),
  defense_9_21_0: Object.freeze({
    id: 'defense_9_21_0',
    name: '9/21/0 Defense',
    trees: Object.freeze({ offense: 9, defense: 21, utility: 0 }),
    ranks: Object.freeze({
      havoc: 3,
      sunder: 3,
      executioner: 1,
      hardiness: 3,
      resistance: 3
    })
  }),
  utility_9_0_21: Object.freeze({
    id: 'utility_9_0_21',
    name: '9/0/21 Utility',
    trees: Object.freeze({ offense: 9, defense: 0, utility: 21 }),
    ranks: Object.freeze({
      havoc: 3,
      sunder: 3,
      executioner: 1,
      good_karma: 2,
      runic_affinity: 1
    })
  })
});

export function listMasteryPagePresetIds() {
  return Object.keys(MASTERY_PAGE_PRESETS);
}
